import { VALUE_TYPES } from "@/static/valueTypes";

export class InputAttributeItem {
  isRequired!: boolean;
  dataType!: VALUE_TYPES;
  enumItems!: null | Array<string>;
}
